import { apiRequest } from "./api";

// Referral link + credit balance (ReferralController). Counts only - the API never says
// which friend filed.
export async function getReferralSummary() {
  return apiRequest("/referrals/me");
}

// Public check used before a ?ref= code is remembered: true if the code belongs to an
// account, false on 404. Any other failure is thrown, not treated as "invalid".
export async function checkReferralCode(code) {
  try {
    await apiRequest(`/referral-codes/check?code=${encodeURIComponent(code)}`, { auth: false });
    return true;
  } catch (err) {
    if (err.status === 404) return false;
    throw err;
  }
}

// FeedbackController. getPendingFeedback(returnId) -> { returnId, businessName, taxYear }
// (all null when there's nothing to rate).
export async function getPendingFeedback(returnId) {
  return apiRequest(returnId ? `/feedback/pending?returnId=${returnId}` : "/feedback/pending");
}

export async function submitFeedback(body) {
  return apiRequest("/feedback", { method: "POST", body });
}

export async function getTestimonialConsents() {
  return apiRequest("/feedback/testimonial-consents");
}

export async function withdrawTestimonialConsent(feedbackId) {
  return apiRequest(`/feedback/${feedbackId}/testimonial-consent`, { method: "DELETE" });
}

// Prompts the filer closed for good: [{ key, scopeId }]. Keys: RATE_RETURN (scopeId =
// return id), SHARE_CARD, REFERRAL_CARD.
export async function getDismissedPrompts() {
  return apiRequest("/prompts/dismissed");
}

export async function dismissPrompt(key, scopeId) {
  return apiRequest(`/prompts/${key}/dismiss`, { method: "POST", body: scopeId ? { scopeId } : {} });
}
